import { clsx } from 'clsx'
import { type FC } from 'react'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { crossSellAccessorGetLocalizedProductDosage } from '../../model/crossSellAccessorGetLocalizedProductDosage'
import { crossSellAccessorGetLocalizedProductUnit } from '../../model/crossSellAccessorGetLocalizedProductUnit'

type CrossSellProductQuantityProps = {
  className?: string
  product?: CrossSellProduct
}

export const CrossSellProductQuantity: FC<CrossSellProductQuantityProps> = ({
  className,
  product,
}) => {
  const { language, tenant } = useGlobalConfigContext()

  return (
    <span className={clsx('cross-sell-product-card-quantity', className)}>
      {product ? (
        [
          `${product.menge} ${crossSellAccessorGetLocalizedProductUnit({
            language,
            product,
            tenant,
          })}`,
          crossSellAccessorGetLocalizedProductDosage({
            language,
            product,
            tenant,
          }),
        ]
          .filter(Boolean)
          .join(' | ')
      ) : (
        <Skeleton className="mx-auto w-1/2" />
      )}
    </span>
  )
}
